/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {AppTypeClothe} from '../../../../model'
import {ModalAddClothe} from '../Modal/ModalAddClothe'
import {createAppLaundry} from '../../../../services'
import {ShowSnackBar} from '../../../../../../util/functions'
import {TabLavanderiaModel} from '../../../../../../models'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'

const TableDetailLaundry: FC = () => {
  const [correlativoId, setCorrelativoId] = useState<string | null>(null)
  const [campamentoId, setCampamentoId] = useState<string | null>(null)
  const {data, setData, loading, setLoading, selectedOn} = useKTable()
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const [showModalNew, setShowModalNew] = useState(false)
  const [detail, setDetail] = useState<any>(null)
  const [idDetail, setIdDetail] = useState(null)
  const handleEdit = (item: AppTypeClothe) => {
    setDetail(item as any)
    setIdDetail(item.item as any)
    setShowModalNew(true)
  }
  const handleAdd = (item: AppTypeClothe) => {
    if (idDetail) {
      let tempItem = data.map((itemDetail) => {
        if (itemDetail.item === idDetail) {
          itemDetail.tipoRopa = item.tipoRopa
          itemDetail.cantidad = item.cantidad
          itemDetail.observacionColor = item.observacionColor
          itemDetail.peso = 1
        }
        return itemDetail
      })
      setData(tempItem)
      ShowSnackBar('Se actualizó el registro correctamente')
    } else {
      let tempItem = {...item, item: data.length + 1}
      data.push(tempItem)
      setData(data)
      ShowSnackBar('Se agregó el registro correctamente')
    }
  }
  const columns: Column<AppTypeClothe>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => (
        <KTableSelectionCellNonMultiple id={props.data[props.row.index].item} />
      ),
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Item' />,
      accessor: 'item',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de ropa' />,
      accessor: 'tipoRopa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'cantidad',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' />,
      accessor: 'observacionColor',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          <div
            className='d-flex justify-content-center flex-shrink-0'
            onClick={() => handleEdit(props.data[props.row.index])}
          >
            <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
              <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
            </a>
          </div>
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])
  const handleNew = () => {
    setShowModalNew(true)
  }
  const handleDelete = () => {
    let result = data.filter((item) => item.item !== selectedOn[0])
    setData(result)
    ShowSnackBar('Se eliminó el registro correctamente')
  }

  const handleCreateOrder = async () => {
    try {
      let request = {
        correlativoId,
        campamentoId,
        detalle: data.map(item => {
          return {
            detalle: { ...item, peso: 1 }
          }
        })
      }
      const response = await createAppLaundry(request as any)
      if (!response.data.error) {
        const obj: TabLavanderiaModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-laundry-app',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar('Se creó el registro correctamente')
        setData([])
      } else {
        ShowSnackBar(response.data.messageSystem, 'error')
      }
    } catch (error) {}
  }
  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-2'>
          <div className='col-sm-12 col-lg-6 d-flex justify-content-start align-items-start'>
            <div className='d-flex justify-content-start'>
              <button
                type='button'
                className='btn btn-primary me-3'
                disabled={data.length === 0}
                onClick={handleCreateOrder}
              >
                Finalizar registro
              </button>
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
              {selectedOn.length > 0 && (
                <button
                  type='button'
                  className='btn btn-primary me-3'
                  disabled={data.length === 0}
                  onClick={handleDelete}
                >
                  Eliminar
                </button>
              )}
            </div>
          </div>
        </div>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <ModalAddClothe
          show={showModalNew}
          setShow={setShowModalNew}
          idPermission={idDetail}
          setIdDetail={setIdDetail}
          setData={handleAdd}
          detailpermission={detail}
          setCorrelativoId={setCorrelativoId}
          setCampamentoId={setCampamentoId}
        />
      </KTCard>
    </>
  )
}

const TableDetailLaundryWrapper = () => {
  return (
    <KTableProvider>
      <TableDetailLaundry />
    </KTableProvider>
  )
}
export {TableDetailLaundryWrapper}
